













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class CollapseRowV2 extends Vue {
  @Prop(String) title!: string;
  @Prop({ default: false }) opened?: boolean;
}
